import React, {Component} from "react";
import PropTypes from "prop-types";
import headerStyles from "./header.module.pcss";
import GrudLogo from "./../../../../components/widgets/grudLogo/grudLogo";

const Header = ({titleDescription}) => {

  return (
    <header className={headerStyles.headTitle}>
      <GrudLogo />
      <p>{titleDescription}</p>
    </header>
  )
};

Header.propTypes = {
  titleDescription: PropTypes.string.isRequired
};

export default Header;


// WEBPACK FOOTER //
// ./src/templates/landing/components/header/header.js